var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:_vm.stepName,scopedSlots:_vm._u([{key:"default",fn:function(observer){return [_c('b-button',{attrs:{"type":"button is-primary next-button","disabled":_vm.block_form},domProps:{"innerHTML":_vm._s(_vm.step._button)},on:{"click":function($event){return _vm.nextStep()}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }